export function initNewsletterCopy() {
  const buttons = document.querySelectorAll("[data-newsletter-copy]");

  buttons.forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.newsletterBound === "true") return;
    button.dataset.newsletterBound = "true";

    button.addEventListener("click", async () => {
      const url = button.dataset.emailUrl;
      const labelIdle = button.dataset.labelIdle || "Copy HTML for Mailchimp";
      const labelDone = button.dataset.labelDone || "Copied!";
      const labelError = button.dataset.labelError || "Copy failed";

      if (!url) return;

      button.disabled = true;

      try {
        const response = await fetch(url, {
          headers: { Accept: "text/html" },
          credentials: "same-origin",
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const html = await response.text();
        await navigator.clipboard.writeText(html);

        button.textContent = labelDone;
        window.setTimeout(() => {
          button.textContent = labelIdle;
          button.disabled = false;
        }, 2000);
      } catch {
        button.textContent = labelError;
        window.setTimeout(() => {
          button.textContent = labelIdle;
          button.disabled = false;
        }, 2500);
      }
    });
  });
}
